var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.814 5.42c.86.232 1.539.914 1.768 1.78C22 8.77 22 12.046 22 12.046s0 3.274-.418 4.845a2.513 2.513 0 01-1.768 1.78c-1.559.42-7.813.42-7.813.42s-6.255 0-7.814-.42a2.514 2.514 0 01-1.768-1.78C2 15.32 2 12.046 2 12.046S2 8.77 2.42 7.2a2.513 2.513 0 011.768-1.78C5.746 5 12 5 12 5s6.254 0 7.813.42zm-4.632 6.645L9.955 9.09v5.948l5.227-2.974z",
    fill: "#ACB5BD"
  })));
}

export default SvgYoutube;